import * as EmailValidator from "email-validator";
import { ERRORS_COPIES } from "../constants/errors.constants";
import useSignUpStore from "../store/useSignUpStore";
import { SIGNUP_FORM_FIELDS } from "../types/signup.types";
import { objectCopy } from "./commons";

export const onFormInputChange = (key: string) => {
  const setSignUpInputsErrors = useSignUpStore.getState().setSignUpInputsErrors;
  const signUpInputsErrors = useSignUpStore.getState().signUpInputsErrors;

  let updatedSignUpInputsErrors = signUpInputsErrors
    ? objectCopy(signUpInputsErrors)
    : {};
  if (updatedSignUpInputsErrors[key]) delete updatedSignUpInputsErrors[key];
  setSignUpInputsErrors(updatedSignUpInputsErrors);
};

export const onFormInputBlur = (
  value: any,
  key: string,
  shouldReturnMessage = false
) => {
  let errorMessage: string = "";
  const setSignUpInputsErrors = useSignUpStore.getState().setSignUpInputsErrors;
  const signUpInputsErrors = useSignUpStore.getState().signUpInputsErrors;

  const inputVal = (value || "").trim();
  if (inputVal !== "") {
    if (key === SIGNUP_FORM_FIELDS.EMAIL) {
      if (!EmailValidator.validate(inputVal)) {
        errorMessage = ERRORS_COPIES.INVALID_EMAIL;
      }
    }
  }
  // } else {
  //   if (key === SIGNUP_FORM_FIELDS.ORG_NAME) {
  //     errorMessage = ERRORS_COPIES.REQUIRED_ORG_NAME;
  //   } else if (key === SIGNUP_FORM_FIELDS.COURSE_CATEGORY) {
  //     errorMessage = ERRORS_COPIES.REQUIRED_COURSE_CATEGORY;
  //   } else if (key === SIGNUP_FORM_FIELDS.PHONE) {
  //     errorMessage = ERRORS_COPIES.REQUIRED_PHONE;
  //   } else if (
  //     key === SIGNUP_FORM_FIELDS.ALREADY_TEACHING ||
  //     SIGNUP_FORM_FIELDS.AUDIENCE_SIZE
  //   ) {
  //     errorMessage = ERRORS_COPIES.REQUIRED_FOR_SET_UP;
  //   } else errorMessage = ERRORS_COPIES.REQUIRED_INPUT;
  // }

  if (errorMessage && !shouldReturnMessage) {
    setSignUpInputsErrors({
      ...signUpInputsErrors,
      [key]: errorMessage,
    });
  }
  if (shouldReturnMessage) {
    return errorMessage;
  }
};

export const getSignupParamsFromURL = () => {
  const search = window.location.search;
  const query = new URLSearchParams(search);

  const skipOnboarding = query.has("skipOnboarding")
    ? query.get("skipOnboarding")
    : null;
  const destination = query.has("destination")
    ? query.get("destination")
    : null;
    
  // Only return destination, skipOnboarding is filtered out to ensure onboarding for all users
  if (destination !== null) {
    return { destination };
  }
  return {};
};
